import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "leovera_admin_token";

export const tokenStorage = {
  get: () => sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => {
    localStorage.removeItem(TOKEN_KEY);
    sessionStorage.removeItem(TOKEN_KEY);
  },
};

export const api = axios.create({
  baseURL: API,
  timeout: 15000,
  headers: { "Cache-Control": "no-cache" },
});

api.interceptors.request.use((config) => {
  const t = tokenStorage.get();
  if (t && config.url && config.url.startsWith("/admin")) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${t}`;
  }
  return config;
});

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const status = error?.response?.status;
    const cfg = error?.config || {};
    const url = cfg.url || "";

    // Network failures are reported as real errors. Admin edits used to be
    // parked in an IndexedDB queue and answered with a fake 202, so the UI said
    // "saved" while nothing reached the server and the queue never drained.
    if (!error.response) error.isNetworkError = true;

    if (status === 401 && url.startsWith("/admin") && !url.endsWith("/login")) {
      tokenStorage.clear();
      if (window.location.pathname.startsWith("/admin") && !window.location.pathname.startsWith("/admin/login")) {
        window.location.href = "/admin/login";
      }
    }
    return Promise.reject(error);
  }
);

export const formatApiError = (err) => {
  if (err?.isNetworkError || (!err?.response && err?.request)) {
    return "Connessione al server non riuscita: la modifica NON è stata salvata. Riprova.";
  }
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Errore sconosciuto";
  if (typeof d === "string") return d;
  if (Array.isArray(d))
    return d.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" · ");
  return JSON.stringify(d);
};
